(() => {
  const gallerySelector = '[data-installation-gallery]';

  class InstallationGallery {
    constructor(element) {
      this.element = element;
      this.triggers = Array.from(
        element.querySelectorAll('[data-installation-gallery-trigger]')
      );

      this.modalId = element.dataset.modalId;
      this.modal = document.getElementById(this.modalId);

      if (!this.triggers.length || !this.modal) return;

      this.image = this.modal.querySelector(
        '[data-installation-gallery-image]'
      );
      this.previousButton = this.modal.querySelector(
        '[data-installation-gallery-previous]'
      );
      this.nextButton = this.modal.querySelector(
        '[data-installation-gallery-next]'
      );
      this.status = this.modal.querySelector(
        '[data-installation-gallery-status]'
      );

      if (!this.image) return;

      this.currentIndex = 0;

      this.bindEvents();
      this.updateNavigationVisibility();
      this.element.dataset.galleryInitialized = 'true';
    }

    bindEvents() {
      this.triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => {
          this.open(index, trigger);
        });
      });

      this.previousButton?.addEventListener('click', () => {
        this.showPrevious();
      });

      this.nextButton?.addEventListener('click', () => {
        this.showNext();
      });

      this.modal.addEventListener('keydown', (event) => {
        if (!this.modal.hasAttribute('open')) return;

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.showPrevious();
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.showNext();
        }
      });
    }

    open(index, opener) {
      if (typeof this.modal.show !== 'function') return;

      this.currentIndex = index;
      this.updateImage();
      this.modal.show(opener);
    }

    showPrevious() {
      if (this.triggers.length < 2) return;

      this.currentIndex =
        (this.currentIndex - 1 + this.triggers.length) %
        this.triggers.length;

      this.updateImage();
    }

    showNext() {
      if (this.triggers.length < 2) return;

      this.currentIndex =
        (this.currentIndex + 1) % this.triggers.length;

      this.updateImage();
    }

    updateImage() {
      const trigger = this.triggers[this.currentIndex];
      const source = trigger.dataset.lightboxSrc;
      const alt = trigger.dataset.lightboxAlt || '';
      const width = trigger.dataset.imageWidth;
      const height = trigger.dataset.imageHeight;

      if (!source) return;

      this.image.alt = alt;

      if (width) {
        this.image.width = Number(width);
      } else {
        this.image.removeAttribute('width');
      }

      if (height) {
        this.image.height = Number(height);
      } else {
        this.image.removeAttribute('height');
      }

      /*
       * The high-resolution image URL exists only in a data attribute.
       * Assigning it here prevents every full-size image from downloading
       * during the initial page load.
       */
      if (this.image.src !== source) {
        this.image.src = source;
      }

      if (this.status) {
        this.status.textContent =
          `${this.currentIndex + 1} / ${this.triggers.length}`;
      }
    }

    updateNavigationVisibility() {
      const hasMultipleImages = this.triggers.length > 1;

      if (this.previousButton) {
        this.previousButton.hidden = !hasMultipleImages;
      }

      if (this.nextButton) {
        this.nextButton.hidden = !hasMultipleImages;
      }
    }
  }

  const initializeGalleries = (root = document) => {
    const galleries = [];

    if (root.matches?.(gallerySelector)) {
      galleries.push(root);
    }

    root.querySelectorAll?.(gallerySelector).forEach((gallery) => {
      galleries.push(gallery);
    });

    galleries.forEach((gallery) => {
      if (gallery.dataset.galleryInitialized === 'true') return;

      new InstallationGallery(gallery);
    });
  };

  const removeSectionModal = (sectionId) => {
    if (!sectionId) return;

    document
      .querySelectorAll('[data-installation-gallery-modal]')
      .forEach((modal) => {
        if (modal.dataset.sectionId !== sectionId) return;

        if (
          modal.hasAttribute('open') &&
          typeof modal.hide === 'function'
        ) {
          modal.hide();
        }

        modal.remove();
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeGalleries();
    });
  } else {
    initializeGalleries();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeGalleries(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    removeSectionModal(event.detail?.sectionId);
  });
})();